function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Box from './Box';
import Button from './Button';
import Flex from './Flex';
import SortAlphaAscIcon from './icons/SortAlphaAscIcon';
import SortAlphaDescIcon from './icons/SortAlphaDescIcon';
import SortAscIcon from './icons/SortAscIcon';
import SortDescIcon from './icons/SortDescIcon';
import SortNumericAscIcon from './icons/SortNumericAscIcon';
import SortNumericDescIcon from './icons/SortNumericDescIcon';
import ListGroup from './ListGroup';
import ListGroupItem from './ListGroupItem';
const ListGroupSortByChooser = /*#__PURE__*/memo(_ref => {
  let {
    items,
    borderRadius,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ListGroup, {
    borderRadius: borderRadius
  }, items && items.map((item, i) => /*#__PURE__*/React.createElement(ListGroupSortByChooserItem, _extends({
    key: i,
    item: item
  }, props))));
});
const ListGroupSortByChooserItem = _ref2 => {
  let {
    item,
    onChoice,
    sortBy,
    sortDirection,
    ...props
  } = _ref2;
  const {
    label,
    value,
    type,
    ...itemProps
  } = item;
  return /*#__PURE__*/React.createElement(ListGroupItem, _extends({}, props, itemProps), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: "1 1 auto"
  }, label), /*#__PURE__*/React.createElement(Button, {
    variant: value === sortBy && sortDirection === 'ASC' ? 'secondary' : 'secondaryOutline',
    size: "small",
    sx: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      outline: 'none',
      px: 3,
      position: 'relative',
      right: '-2px'
    },
    onClick: () => onChoice(value, 'ASC', label)
  }, type === 'alpha' ? /*#__PURE__*/React.createElement(SortAlphaAscIcon, null) : type === 'numeric' ? /*#__PURE__*/React.createElement(SortNumericAscIcon, null) : /*#__PURE__*/React.createElement(SortAscIcon, null)), /*#__PURE__*/React.createElement(Button, {
    variant: value === sortBy && sortDirection === 'DESC' ? 'secondary' : 'secondaryOutline',
    size: "small",
    sx: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      outline: 'none',
      px: 3
    },
    onClick: () => onChoice(value, 'DESC', label)
  }, type === 'alpha' ? /*#__PURE__*/React.createElement(SortAlphaDescIcon, null) : type === 'numeric' ? /*#__PURE__*/React.createElement(SortNumericDescIcon, null) : /*#__PURE__*/React.createElement(SortDescIcon, null))));
};
ListGroupSortByChooser.propTypes = {
  ...Flex.propTypes,
  items: PropTypes.array.isRequired
};
ListGroupSortByChooser.defaultProps = {};
ListGroupSortByChooser.displayName = 'ListGroupSortByChooser';
export default ListGroupSortByChooser;